/**
 * Ключи ошибок валидации бэка → текст для админа.
 *
 * Обычно бэк присылает уже переведённый текст (запросы идут с
 * Accept-Language: ru), но для новых правил перевод на бэке появляется не
 * сразу, и тогда в тосте виден голый ключ вроде validation.giveaway_game_locked.
 * Здесь — только такие ключи; всё остальное показывается как пришло.
 */
export const VALIDATION_MESSAGES = {
    'validation.giveaway_game_locked': 'Игру розыгрыша уже нельзя изменить',
}

export function humanizeValidation(message) {
    if (typeof message !== 'string') return message
    return VALIDATION_MESSAGES[message.trim()] || message
}

/**
 * errors из ответа Laravel ({field: [msg, …]}) с переведёнными ключами —
 * для ValidationObserver.setErrors, чтобы ошибка встала под своим полем.
 */
export function humanizeErrors(errors) {
    if (!errors || typeof errors !== 'object') return {}
    return Object.fromEntries(
        Object.entries(errors).map(([field, messages]) => [
            field,
            [].concat(messages).filter(Boolean).map(humanizeValidation),
        ])
    )
}
